import $ from "jquery";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { initPropertySliderEmbla } from "./property-slider-embla.js";
import {
  appendSectionHeadlineReveal,
  SECTION_HEADLINE_DURATION,
} from "./section-headline-gsap.js";

gsap.registerPlugin(ScrollTrigger);

// Homepage “Unsere Neuzugänge” slider (index.php) + property related slider.
$(".property-slider").each(function () {
  initPropertySliderEmbla(this);
});

const $homePropertySliders = $(".property-slider").not(
  ".property-slider.property__section",
);

if (
  $homePropertySliders.length &&
  !window.matchMedia("(prefers-reduced-motion: reduce)").matches
) {
  $homePropertySliders.each(function initHomePropertySliderGsap() {
    const $propertySlider = $(this);
    const headline = $propertySlider.find("> .page-section__headline").get(0);
    const slideInners = $propertySlider
      .find(".property-slider__slide-inner")
      .toArray();

    gsap.context(() => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: $propertySlider[0],
          start: "top 85%",
          toggleActions: "play none none none",
        },
        defaults: { ease: "power2.out" },
      });

      appendSectionHeadlineReveal(tl, headline, 0);

      if (slideInners.length) {
        const slideDelayAfterHeadline = headline ? 0.28 : 0;
        tl.from(
          slideInners,
          {
            autoAlpha: 0,
            y: 32,
            duration: SECTION_HEADLINE_DURATION,
            ease: "power2.out",
            force3D: true,
          },
          slideDelayAfterHeadline,
        );
      }
    }, $propertySlider[0]);
  });
}
